import { render } from "./LoanList.vue?vue&type=template&id=7451027a&scoped=true"
import script from "./LoanList.vue?vue&type=script&lang=js"
export * from "./LoanList.vue?vue&type=script&lang=js"

import "./LoanList.vue?vue&type=style&index=0&id=7451027a&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7451027a"]])

export default __exports__